/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment'
import 'moment/locale/pt';
import { Box, Button, Modal, Typography } from '@mui/material';

import FixedContainer from '../../components/Container';
import LoadingComponent from '../../components/LoadingComponent';
import CustomizedTables from '../../components/Table';
import NewBrancheModal from './components/newBrancheModal';
import { useNavigate } from 'react-router-dom';
import { GetFetch, urls } from '../../services/apiBase';

const Branches = props => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);

  const [listFarmHouse, setListFarmHouse] = useState(null);

  const navigate = useNavigate()

  const COLUMNSTABLE = [
    {
      headerName: 'Prioridade',
      type: 'deafult',
      value: {
        first: {
          value: 'priority'
        },
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Nome',
      type: 'default',
      value: {
        first: {
          value: 'name'
        }
      }
    },
    {
      headerName: 'Proprietário',
      type: 'default',
      value: {
        first: {
          value: 'owner'
        }
      }
    },
    {
      headerName: 'Nascionalidade do proprietário',
      type: 'default',
      value: {
        first: {
          value: 'owner_nationality'
        }
      }
    },
    {
      headerName: 'CPF/CNPJ',
      type: 'DOCUMENT',
      value: {
        first: {
          value: 'owner_document'
        }
      }
    },
    {
      headerName: 'Estado Civil',
      type: 'default',
      value: {
        first: {
          value: 'onwer_marital'
        }
      }
    },
    {
      headerName: 'Numero de registro',
      type: 'default',
      value: {
        first: {
          value: 'register_number'
        }
      }
    },
    {
      headerName: 'Endereço',
      type: 'default',
      value: {
        first: {
          value: 'address'
        }
      }
    },
    {
      headerName: 'Cidade',
      type: 'default',
      value: {
        first: {
          parent: ['city'],
          value: 'name_city'
        }
      }
    },
    {
      headerName: 'UF',
      type: 'default',
      value: {
        first: {
          parent: ['city'],
          value: 'code_uf'
        }
      }
    },
    {
      headerName: 'País',
      type: 'default',
      value: {
        first: {
          parent: ['city'],
          value: 'name_country'
        }
      }
    },
  ]

  const handleOpenNewModal = () => {
    setOpenNewModal(true)
  }

  const handleClose = () => {
    setOpenNewModal(false);
  }

  const handleOpenDetails = (farmHouse) => {
    return navigate('/brancheDetails', { state: { farmHouse: farmHouse } })
  }

  const getListFarmHouse = useCallback(async () => {
    setLoading(true)
    try {
      const response = await GetFetch(urls.GET_LIST_FARMHOUSE);
      setListFarmHouse(response.data);
      setError(false)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, []);

  const tableComponent = () => {
    return (
      <Box>
        {listFarmHouse && listFarmHouse.length > 0
          ?
          <>
            <CustomizedTables
              data={listFarmHouse}
              columns={COLUMNSTABLE}
              options
              action={handleOpenDetails}
            />
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas filiais
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as filiais
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    getListFarmHouse()
  }, []);

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            Filiais
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>

            <Box>
              <Button variant="contained" color='success' sx={{ marginRight: 2 }} onClick={handleOpenNewModal}>Novo</Button>
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
              listFarmHouse && listFarmHouse.length === 0 ?
                <Box sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'center'
                }}>
                  <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                    No momento não existem filiais para listar
                  </Typography>
                </Box>
                :
                <>
                  {tableComponent()}
                </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={openNewModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NewBrancheModal
          onClose={handleClose}
          getList={getListFarmHouse}
          editPromoCode={{}}
          onEdit={false}
        />
      </Modal>
    </>
  );
}

export default Branches;
